import { Lock } from "lucide-react";
import { Logo } from "../shared/Logo";
import { Badge } from "../shared/Badge";

export function NicheTopBar({ badge }: { badge: string }) {
  return (
    <div data-testid="niche-topbar" className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <Logo testId="niche-logo-link" />
        <Badge testId="niche-security-badge"><Lock aria-hidden="true" className="h-3 w-3" />{badge}</Badge>
      </div>
    </div>
  );
}
